<wiz-vgroup width="150px" height="200px" class="section-container">
  <wiz-list
    width="100%"
    height="100%"
    [wizLabelField]="'label'"
    [wizItemRenderer]="languageRenderer"
    [wizDataProvider]="languageListDS"
  >
  </wiz-list>
</wiz-vgroup>
